/** Contact intent only. Never sends the link, phone number, email, page path or medical context. */
(() => {
  const measurementId = document.currentScript?.dataset.measurementId;
  if (!measurementId || window.__kieuContactTracking) return;
  window.__kieuContactTracking = true;
  document.addEventListener('click', (event) => {
    if (!event.isTrusted) return;
    const anchor = event.target?.closest?.('a[href]');
    const href = anchor?.getAttribute('href') || '';
    const method = /^tel:/i.test(href) ? 'phone' : /^mailto:/i.test(href) ? 'email' : null;
    if (method) window.KieuBookingGA4?.sendContact({ measurementId }, method);
  }, { passive: true });
})();
